import axios from "axios";
import { BACKEND_URL } from "@/data/site";

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg ?? "").join(" ");
  return "Something went wrong. Please try again.";
};
